let navItems = [
	[{ title: "Accueil", icon: "home.png", link: "/", bg: "transparent" }],
	[
		{ title: "Mes boosters", icon: "boosters.png", link: "/boosters", bg: "cyan" },
		{ title: "Mes collections", icon: "collections.png", link: "/collections", bg: "cyan" },
	],
	[
		{ title: "Mes statistiques", icon: "stats.png", link: "/statistics", bg: "purple" },
		{ title: "Mes succès", icon: "achievements.png", link: "/achievements", bg: "purple" },
		{ title: "Classement", icon: "leaderboard.png", link: "/leaderboard", bg: "purple" },
		{ title: "Codes", icon: "codes.png", link: "/codes", bg: "purple" },
	],
	[
		{ title: "Casino", icon: "casino.png", link: "/casino", bg: "lime" },
		{ title: "Boutique", icon: "shop.png", link: "/shop", bg: "lime" },
		{ title: "Salle des coffres", icon: "treasureRoom.png", link: "/treasure-room", bg: "lime" },
		{ title: "Échanges", icon: "trades.png", link: "/trades", bg: "lime" },
		{ title: "Marché Noir", icon: "blackMarket.png", link: "/black-market", bg: "lime" },
		// { title: "Hotel des ventes", icon: "auction.png", link: "/auction", bg: "lime" },
	],
	[
		{ title: "Utilisateurs", icon: "users.png", link: "/users", bg: "red" },
		{ title: "Generateur de codes", icon: "codesGenerator.png", link: "/codesGenerator", bg: "red" },
		{ title: "Config", icon: "config.png", link: "/config", bg: "red" },
		{ title: "Logs", icon: "logs.png", link: "/logs", bg: "red" },
	],
]

export default navItems
